// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ml-c";
export var backButton = "_ml-4";
export var backIcon = "_ml-5";
export var chevronShortcut = "_ml-6";
export var container = "_ml-1";
export var editor = "_ml-8";
export var editorWrapper = "_ml-7";
export var prefix = "_ml-2";
export var searchIcon = "_ml-3";
export var suffix = "_ml-9";
export var suffixContent = "_ml-a";
export var suffixText = "_ml-b";
export var wrapper = "_ml-0";